import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';

// Oculta el elemento cuando la sesión es de guest B2C — es decir, cuando
// necesita contexto de agencia real que un invitado no tiene (comisión,
// medios de pago de agencia, selector de agencia, back-office, etc.).
@Directive({
  selector: '[appAgencyOnly]'
})
export class AgencyOnlyDirective implements OnInit {
  constructor(
    private tpl: TemplateRef<any>,
    private vcr: ViewContainerRef,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    if (!this.userService._isGuest) {
      this.vcr.createEmbeddedView(this.tpl);
    }
  }
}
